"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SectionHeader;
const jsx_runtime_1 = require("react/jsx-runtime");
const SectionCard_1 = __importDefault(require("./SectionCard"));
function SectionHeader(props) {
    const { className, color, image, children } = props, others = __rest(props, ["className", "color", "image", "children"]);
    const classes = `ui-section-header ${className ? className : ""}`;
    return ((0, jsx_runtime_1.jsx)(SectionCard_1.default, Object.assign({ color: color, className: classes }, others, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row flex-start p-4", children: [(0, jsx_runtime_1.jsx)("img", { src: image, width: 46, height: 46, alt: "" }), (0, jsx_runtime_1.jsx)("div", { className: "ml-2 text-lg/6", children: children })] }) })));
}
